import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const {
  listingBegin,
  listingSuccess,
  listingErr,

  listingDeleteBegin,
  listingDeleteErr,
  listingDeleteSuccess,

  listingDetailBegin,
  listingDetailErr,
  listingDetailSuccess,

  createOrUpdateListingBegin,
  createOrUpdateListingSuccess,
  createOrUpdateListingErr,

  hostPartnerCoverageBegin,
  hostPartnerCoverageSuccess,
  hostPartnerCoverageErr,

  downloadQrcodeBegin,
  downloadQrcodeSuccess,
  downloadQrcodeErr,

  listingContentBegin,
  listingContentSuccess,
  listingContentErr,

  chatStatusBegin,
  chatStatusSuccess,
  chatStatusErr,

  exportListingDataBegin,
  exportListingDataSuccess,
  exportListingDataErr,

  nearbyPlacesBegin,
  nearbyPlacesSuccess,
  nearbyPlacesErr,

  fetchThemebyHostBegin,
  fetchThemebyHostSuccess,
  fetchThemebyHostErr,

  fetchPermissionbyHostBegin,
  fetchPermissionbyHostSuccess,
  fetchPermissionbyHostErr

} = actions;

const ListingListAPI = '/admin/listing-list';
const GetListingDetailAPI = '/admin/listing-detail/';
const DeleteListing = '/admin/delete-listing/';
const CreateOrUpdateListingAPI = '/admin/add-edit-listing';
const GetListingSlugAPI = '/admin/get-slug';
const HostPartnerCoverageAPI = '/admin/host-partner-coverage/';
const generateQrCodeAPI = 'generate-qr-code/';
const listingContent = '/admin/get-listing-content';
const getChatStatus = '/admin/get-chat-status/';
const exportListingDataAPI = '/admin/export-listing-data';
const coptListingAPI = '/admin/copy-listing';
const getNearbyPlacesAPI = '/admin/nearby-places';
const importPMSListingAPI = '/admin/import-pms-listings';
const fetchThemebyHostAPI = '/admin/get-configurations';
const fetchPermissionbyHostAPI = '/admin/feature-permission';

const listingList = (values) => {
  return async (dispatch) => {
    dispatch(listingBegin());
    try {
      const response = await DataService.post(ListingListAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingErr(response?.data?.message));
      } else {
        dispatch(listingSuccess(response?.data));
      }
      return response?.data?.result;
    } catch (err) {
      dispatch(listingErr(err));
    }
  };
};

const getListingDetail = (values) => {
  return async (dispatch) => {
    dispatch(listingDetailBegin());
    try {
      const response = await DataService.get(GetListingDetailAPI + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingDetailErr(response?.data?.message));
      } else {
        dispatch(listingDetailSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(listingErr(err));
    }
  };
};

const getHostPartnerCoverage = (values) => {
  return async (dispatch) => {
    dispatch(hostPartnerCoverageBegin());
    try {
      const response = await DataService.get(HostPartnerCoverageAPI + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(hostPartnerCoverageErr(response?.data?.message));
      } else {
        dispatch(hostPartnerCoverageSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(hostPartnerCoverageErr(err));
    }
  };
};

const listingDelete = (values) => {
  return async (dispatch) => {
    dispatch(listingDeleteBegin());
    try {
      const response = await DataService.delete(DeleteListing + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingDeleteErr(response?.data?.message));
      } else {
        dispatch(listingDeleteSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(listingDeleteErr(err));
    }
  };
};

const creatOrUpdateListing = (values, callback) => {
  return async (dispatch) => {
    dispatch(createOrUpdateListingBegin());
    try {
      const response = await DataService.post(CreateOrUpdateListingAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(createOrUpdateListingErr(response?.data?.message));
      } else {
        dispatch(createOrUpdateListingSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(createOrUpdateListingErr(err));
    }
  };
};

const getListingSlug = () => {
  return async (dispatch) => {
    dispatch(listingDetailBegin());
    try {
      const response = await DataService.get(GetListingSlugAPI);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingDetailErr(response?.data?.message));
      } else {
        dispatch(listingDetailSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(listingErr(err));
    }
  };
};


const downloadQrCode = (listingSlug, actionType) => {
  return async (dispatch) => {
    dispatch(downloadQrcodeBegin());
    try {
      const endPoint = `${process.env.REACT_APP_API_ENDPOINT}generate-qr-code/${listingSlug}?action_type=${actionType}`;
      window.open(endPoint, '_blank');
    } catch (err) {
      dispatch(downloadQrcodeErr(err));
    }
  };
};

const getListingContent = () => {
  return async (dispatch) => {
    dispatch(listingContentBegin());
    try {
      const response = await DataService.get(listingContent);
      if (response?.data?.status === HttpStatus.HTTP_OK) {
        dispatch(listingContentSuccess(response));
      }
      return response?.data?.result;
    } catch (err) {
      dispatch(listingContentErr(err));
    }
  };
};

const getChatEnableStatus = (values) => {   // chat enable status
  return async (dispatch) => {
    dispatch(chatStatusBegin());
    try {
      const response = await DataService.get(getChatStatus  + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(chatStatusErr(response?.data?.message));
      } else {
        dispatch(chatStatusSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(chatStatusErr(err));
    }
  };
};

const exportListingData = (values) => {
  return async (dispatch) => {
    dispatch(exportListingDataBegin());
    try {
      const response = await DataService.export(exportListingDataAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(exportListingDataErr(response?.data?.message));
      } else {
        dispatch(exportListingDataSuccess(response?.data));
      }
      return response;
    } catch (err) {
      dispatch(exportListingDataErr(err));
    }
  };
};


const copyListingData = (values) => {
  return async (dispatch) => {
    dispatch(listingBegin());
    try {
      const response = await DataService.post(coptListingAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingErr(response?.data?.message));
      } else {
        dispatch(listingSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(listingErr(err));
    }
  };
};

/* google map api for nearby places */
const getNearbyPlaces = () => {
  return async (dispatch) => {
    dispatch(nearbyPlacesBegin());
    try {
      const response = await DataService.post(getNearbyPlacesAPI);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(nearbyPlacesErr(response?.data?.message));
      } else {
        dispatch(nearbyPlacesSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(nearbyPlacesErr(err));
      return [];
    }
  }
};

const importPMSListing = () => {
  return async (dispatch) => {
    dispatch(listingBegin());
    try {
      const response = await DataService.get(importPMSListingAPI);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(listingErr(response?.data?.message));
      } else {
        dispatch(listingSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(listingErr(err));
    }
  };
};

const fetchThemebyHost = (values) => {
  return async (dispatch) => {
    dispatch(fetchThemebyHostBegin());
    try {
      const response = await DataService.post(fetchThemebyHostAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(fetchThemebyHostErr(response?.data?.message));
      } else {
        dispatch(fetchThemebyHostSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(fetchThemebyHostErr(err));
    }
  };
};

const fetchPermissionbyHost = (values) => {
  return async (dispatch) => {
    dispatch(fetchPermissionbyHostBegin());
    try {
      const url = fetchPermissionbyHostAPI + '?host_slug='+ values
      const response = await DataService.get(url);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(fetchPermissionbyHostErr(response?.data?.message));
      } else {
        dispatch(fetchPermissionbyHostSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(fetchPermissionbyHostErr(err));
    }
  };
};

export { listingList, getListingDetail, listingDelete, creatOrUpdateListing, getListingSlug, getHostPartnerCoverage, downloadQrCode, getListingContent, exportListingData, copyListingData, getChatEnableStatus, getNearbyPlaces, importPMSListing ,fetchThemebyHost ,fetchPermissionbyHost };
